// modules
import { createSelector } from 'reselect'
import { get, isArray } from 'lodash'

// utils
import { caregiverProfile$ } from 'src/store/modules/caregiver/profile'

export const accessRestrictions$ = (state = {}) =>
  get(state, ['caregiver', 'accessRestrictions'], {})

export const caregiverAssignedFacilities$ = createSelector(
  caregiverProfile$,
  (caregiverProfile = {}) => {
    const facility = get(caregiverProfile, ['facility'], [])

    return isArray(facility) ? facility : []
  }
)

export const caregiverAssignedPatients$ = createSelector(
  accessRestrictions$,
  (accessRestrictions = {}) => get(accessRestrictions, ['assignedPatients'], [])
)

export const caregiverSearchedPatients$ = createSelector(
  accessRestrictions$,
  (accessRestrictions = {}) => get(accessRestrictions, ['searchedPatients'], [])
)
